<template>
    <v-card outlined class="d-flex flex-column  quote-card">
        <BaseTimer v-if="currentQuoteForTimer" :timeLimit="currentQuoteForTimer.expiration"
            @timeDue="() => $emit('declineQuote', 'timer_expired')" />

        <v-row class="mb-2 pa-2  justify-center mt-1 ">
            <v-col cols="12" sm="5" class="d-flex justify-space-around  flex-column align-center flex-sm-row-reverse">

                <div class="d-flex flex-column align-start">

                    <!--total volume-->
                    <div class=" mr-3 light-input-text">
                        {{ $t('quoteInfo.total') }}
                    </div>

                    <div class="line-height best-rate-and-total">
                         {{calculateBestRateTotal }}
                    </div>


                </div>

                <div class="d-flex flex-column align-start">
                    <span class="ml-3 light-input-text">
                        {{ $t('quoteInfo.bestRate') }}
                    </span>
                    <span class="ml-3 line-height best-rate-and-total">
                        {{ formatBestRate }}
                    </span>
                </div>

                <div class="d-flex flex-column align-start">
                    <div class=" mr-3 light-input-text">
                        {{ $t('quoteInfo.amount') }}
                    </div>
                    <!-- convertToMoney(rfqBase.rfq_orderqty) ?? "44,444.44"  -->
                    <div class="line-height best-rate-and-total">
                        {{ gridActive ? amount : "-" }}
                    </div>
                </div>
                
            </v-col>

            <div></div>
            <v-col cols="12" sm="2" class="d-flex flex-1 justify-center align-center flex-gap-2">
                <v-btn elevation="0"  tile color="primary" @click="openConfirmation(bestRate)" :disabled="disabledButton"
                    class="rounded">
                    <span class="black--text " :class="{ 'text--disabled': disabledButton }">
                        {{ $t('instructions.accept') }}
                    </span>
                </v-btn>

                <v-btn elevation="0" tile outlined class="rounded " @click="declineQuote" color="grey darken-2"
                    :disabled="disabledButton">
                    <span class="white--text rounded" :class="{ 'text--disabled': disabledButton }">
                        {{ $t('instructions.decline') }}
                    </span>
                </v-btn>
            </v-col>

            <v-col cols="12" sm="5" class="d-flex flex-2  justify-center flex-column align-center flex-sm-row">
                <div v-if="isSpot" class="d-flex flex-column align-start">
                    <span class="mr-2 light-input-text">
                        {{ $t('quoteInfo.spreadPtax') }}
                    </span>
                    <span class=" best-rate-and-total line-height">
                         {{ bankRows[0]?.rfq_ptax }} 
                    </span>
                </div>

            </v-col>
        </v-row>
        <v-divider class="my-1"></v-divider>
        <v-row no-gutters class="my-2 d-flex justify-space-between flex-grow-1">
            <v-col v-for="col in quoteCols" :key="col.key" :cols="col.cols">
                <div class="d-flex flex-column align-center">
                    <div class="pt-1 pa-2 text-center light-input-text">
                        {{ col.label }} 
                    </div>
                </div>
            </v-col>
        </v-row>
        <div>
        </div>
        <v-row v-for="bankQuote in bankRows" :key="bankQuote.rfq_quote_id || bankQuote.bank_id" :class="[
            bestRateColor(bankQuote).fontWeight,
            bestRateColor(bankQuote).backgroundColor
        ]" no-gutters class="align-center d-flex justify-space-between flex-grow-1 ">
            <v-col v-for="col in quoteCols" :key="col.key" :cols="col.cols" :style="col.bankCell ? 'background:#15171c; border:2px solid #15171c': '' ">
                
                <div class="pa-2 text-center text-truncate ">
                    {{ col.getValue(bankQuote) ?? '-'}}
                </div>
            </v-col>

            <!--<v-col style="background:#15171c; " cols="1">
                    <div class="pa-2 text-center border-right-grid border-bottom-grid">
                        <v-btn elevation="0" tile  color="primary" small @click="openConfirmation(bankQuote)"
                        :disabled="disableGrid" class="rounded" style="width: 80px">
                            <span class="black--text " :class="{ 'text--disabled': disableGrid }">
                                {{ $t('instructions.accept') }}
                            </span>
                        </v-btn>
                    </div>
            </v-col>-->
        </v-row>
    </v-card>
</template>

<script>
import BaseTimer from '@/components/common/BaseTimer.vue'
import { getDateYYYYMMDD } from '@/utils/utils';

export default {
    props: {
        amount: [String, Number],
        money: Object,
        loadingNewRfq: Boolean,
        gridActive: Boolean,
        disableQuoteButton: Boolean,
        disableGrid: Boolean,
        bankList: Array,
        bestRate: Object,
        selectedSpread: {
            type: [Number, String],
            default: null,
        },
        isBroker: {
            type: Boolean,
            default: false,
        },
        isSpot: {
            type: Boolean,
            default: true
        },
        quote: Array,
        quoteList: Array,
        currentQuoteForTimer: {
            required: false
        }
    },
    components: {
        BaseTimer
    },

    computed: {
        rfqBase() {
            return this.quoteList?.[0] ?? {}
        },
        bankRows() {
            if(!this.rfqBase) return;
            return (this.rfqBase.rfq_quote ?? []).filter(q =>
                q.rfq_quote_px_client != null &&
                !isNaN(Number(q.rfq_quote_px_client))
            )
        },
        quoteCols() {
            //px client = spotrate + spread

            if (!this.quoteList?.length) return [];

            const baseColumns = [
                {
                    key: "bank",
                    cols: 2,
                    label: this.$t("quoteInfo.bank"),
                    getValue: (bankQuote) =>
                        bankQuote.bank_name || bankQuote.counterparty_name || this.$t("plexus.quoteGrid.defaultBankName"),
                    bankCell: true,
                },
            ]

            const spotColumns = [
                {
                    key: "spreadPtax",
                    cols: 1,
                    label: this.$t("quoteInfo.spreadPtax"),
                    getValue: (bankQuote) =>
                        bankQuote.rfq_quote_spread_avg ||  '',
                    rateCell: true,
                },                {
                    key: "spread",
                    cols: 1,
                    label: this.$t("quoteInfo.spread"),
                    getValue: (bankQuote) =>
                        bankQuote.rfq_side === "BUY" ?  Number(bankQuote.rfq_quote_px_client) - Number(bankQuote.rfq_quote_spotrate) : Number(bankQuote.rfq_quote_spotrate) - Number(bankQuote.rfq_quote_px_client)  ||  '',
                    rateCell: true,
                },
                {
                    key: "rate",
                    cols: 2,
                    label: this.$t("pricer.spot"),
                    getValue: (bankQuote) =>
                        this.formatRate(bankQuote.rfq_quote_spotrate),
                    rateCell: true,
                },
            ]

            const ndfColumns = [
                {
                    key: "points",
                    cols: 2,
                    label: this.$t("pricer.forwardRate"),
                    getValue: (bankQuote) => {
                        const fwd = bankQuote.rfq_quote_fwdpoints
                        const spot = bankQuote.rfq_quote_spotrate
                        return (fwd != null && spot != null) ? (fwd + spot).toFixed(4) : "4.9856"
                    },
                    rateCell: true,
                },
                {
                    key: "spotRate",
                    cols: 2,
                    label: this.$t("pricer.spot"),
                    getValue: (bankQuote) =>
                    this.formatRate(bankQuote.rfq_quote_spotrate) ?? "4.9500",
                    rateCell: true,
                },
                {
                    key: "fPoints",
                    cols: 2,
                    label: this.$t("pricer.points"),
                    getValue: (bankQuote) =>
                        bankQuote.rfq_quote_fwdpoints || "0.356",
                    rateCell: true,
                },

            ]
            const sharedColumns = [
                {
                    key: "parity",
                    cols: 1,
                    label: this.$t("quoteInfo.parity"),
                    getValue: () =>
                        this.rfqBase.rfq_symbol || "-",
                },
                
                {
                    key: "settlement",
                    cols: 2,
                    label: this.isSpot
                        ? this.$t("quoteInfo.settlement")
                        : this.$t("quoteInfo.maturityText"),
                    getValue: () =>
                        this.isSpot
                            ? (this.rfqBase?.rfq_settlement.toUpperCase()|| '-')
                            : (this.rfqBase?.rfq_settlement.toUpperCase()|| '-'),
                },
                    {
                    key: "side",
                    cols: 1,
                    label: this.$t("quoteInfo.side"),
                    getValue: () =>
                        this.rfqBase.rfq_side || "-",
                },
            ]

            return [
                ...baseColumns,
                ...(this.isSpot ? spotColumns : ndfColumns),
                ...sharedColumns,
            ]
        },
        disabledButton() {
            return this.disableGrid || !this.bankRows.length
        },
        formatBestRate(){
            if (!this.bestRate || isNaN(Number(this.bestRate.rfq_quote_px_client))) {
            return "-"
            }
             if (this.bestRate.security?.toUpperCase()?.includes("NDF"))
             {
                return ((this.bestRate?.rfq_quote_px_client).toFixed(4)) 
             }
             return this.bestRate.rfq_quote_px_client === 0 ? `${this.$t('broker.labels.waiting')}` : Number(this.bestRate.rfq_quote_px_client).toFixed(4);
        },
        calculateBestRateTotal(){
            if (!this.bestRate) return '-'
            const total = Number(this.bestRate.rfq_quote_px_client) * this.amount
            return !isNaN(total) ? total.toFixed(2) : '-'
        }
    },

    methods: {
        colorRow(bankQuote) {
            if (!this.bestRate || !bankQuote) return 'gridSurface'
            return bankQuote.rfq_quote_id === this.bestRate.rfq_quote_id ? 'gridSurfaceHighlight' : 'gridSurface'
        },
        bestRateColor(bankQuote) {
            if (!this.bestRate || !bankQuote) return 'gridSurface'
            const isBestRate = bankQuote.rfq_quote_id === this.bestRate.rfq_quote_id;
            const colored = {
                fontWeight: isBestRate ? "font-weight-bold" : "font-weight-light",
                backgroundColor: isBestRate ? "gridSurfaceHighlight" : "gridSurface",
            }
            return colored;
        },
        openConfirmation(quoteItem) {
            const selecteQuote = { ...quoteItem, rfq_id: this.rfqBase.rfq_id }
            this.$emit("openConfirmation", selecteQuote)
        },
        declineQuote() {
            this.$emit("declineQuote")
        },
        formatRate(v) {
            const n = Number(v)
            return (!v || isNaN(n) || n === 0) ? '-' : n.toFixed(4)
        },
        convertToMoney(amount) {
            if (!amount || isNaN(amount)) return '-'
            return amount.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        }
    }
}
</script>
<style scoped>
.border-bottom-grid {
    border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}
.quote-card{
    margin: 1.5rem auto;
    max-width:1250px;
}
.best-rate-and-total {
    /*color: #31c030;*/
    font-weight: bold;
    min-width: 74px;
    font-size: 20px !important;
    white-space: nowrap;

}

</style>
